<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
        <div class="section-1400 pt-xl-4">
            <div class="container-fluid padding-top-40">
                <div class="row justify-content-center">
                    <div class="col-xl-8">
                        <div
                                class="section py-4 py-md-5 px-3 px-sm-4 px-lg-5 over-hide border-4 section-shadow-blue bg-white form"
                        >
                            <form class="nfr-form-standard" [formGroup]="contactForm" (ngSubmit)="sendMessage()">
                                <div class="row justify-content-center">
                                    <div class="col-12 text-center mb-5 pb-lg-3">
                                        <h6 class="color-primary text-uppercase mb-2">Contact Us</h6>
                                        <strong class="display-8 mb-4 color-gray-dark">
                                            Please post your question below for RANA National Executive Committee
                                        </strong>
                                    </div>

                                    <!-- Name -->


                                    <div class="col-md-6 col-xl-4 mt-4">
                                        <small class="error-text">
      <span *ngIf="name?.invalid && (name?.dirty || name?.touched)">
        <span *ngIf="name?.errors?.['required']" class="font-weight-500">Name is required.</span>
      </span>
                                        </small>
                                        <div class="form-group position-relative">
                                            <input
                                                    type="text"
                                                    formControlName="name"
                                                    class="form-style big form-style-with-icon section-shadow-blue"
                                                    placeholder="Your Name"
                                                    autocomplete="off"
                                            />
                                            <i class="input-icon big uil uil-user"></i>

                                            <!-- Error message container always present -->

                                        </div>
                                    </div>

                                    <!-- Phone -->
                                    <div class="col-md-6 col-xl-4 mt-4">
                                        <small class="error-text">
      <span *ngIf="name?.invalid && (name?.dirty || name?.touched)">
        <span *ngIf="name?.errors?.['required']">&nbsp;</span>
      </span>
                                        </small>
                                        <div class="form-group position-relative">
                                            <input
                                                    type="text"
                                                    formControlName="phone"
                                                    class="form-style big form-style-with-icon section-shadow-blue"
                                                    placeholder="Your phone here"
                                                    autocomplete="off"
                                            />
                                            <i class="input-icon big uil uil-phone"></i>
                                            <small class="error-text">&nbsp;</small> <!-- empty for alignment -->
                                        </div>
                                    </div>


                                    <!-- Email -->
                                    <div class="col-md-8 col-xl-8 mt-4">
                                        <div *ngIf="email?.invalid && (email?.dirty || email?.touched)">
                                            <small *ngIf="email?.errors?.['required']" class="font-weight-500">
                                                Email is required.
                                            </small>
                                            <small *ngIf="email?.errors?.['email']" class="font-weight-500">
                                                Invalid email format.
                                            </small>
                                        </div>
                                        <div class="form-group">
                                            <input
                                                    type="email"
                                                    formControlName="email"
                                                    class="form-style big form-style-with-icon section-shadow-blue"
                                                    placeholder="Your email here"
                                                    autocomplete="off"
                                            />
                                            <i class="input-icon big uil uil-at"></i>
                                        </div>
                                    </div>

                                    <!-- Message -->
                                    <div class="col-xl-8 mt-4">
                                        <div *ngIf="message?.invalid && (message?.dirty || message?.touched)">
                                            <small *ngIf="message?.errors?.['required']" class="font-weight-500">
                                                Message is required.
                                            </small>
                                        </div>

                                        <div class="form-group">
                      <textarea
                              formControlName="message"
                              class="form-style big form-style-with-icon form-textarea section-shadow-blue"
                              placeholder="Message"
                              rows="5"
                      ></textarea>
                                            <i class="input-icon big uil uil-comment-alt-lines"></i>
                                        </div>
                                    </div>

                                    <!-- Submit -->
                                    <div class="col-12 text-center pt-5">
                                        <button
                                                class="btn btn-primary"
                                                [disabled]="contactForm.invalid || submitting"
                                                (click)="sendMessage()">
                                            {{ submitting ? 'Sending...' : 'Send Message' }}
                                        </button>
                                    </div>
                                </div>
                            </form>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

